/*import { useState } from "react";
import Section from "../components/Section";
import Button from "../components/Button";

const apiserv = "service_q9i9znn";
const tempid = "template_phvxffe";
const pubkey = "ILvGu9pmcklhCJ-_O";

function Contact() {
  const rediPintrest = () => {
    window.location.href = "https://pin.it/1agZp2YNs";
  };

  const rediFacebook = () => {
    window.location.href = "https://www.facebook.com/devdavid.welengenzu.3";
  };

  const rediInstagram = () => {
    window.location.href =
      "https://www.instagram.com/dev__well/profilecard/?igsh=czc4dXlucmU1aWx1";
  };

  const rediLinkdin = () => {
    window.location.href = " https://www.linkedin.com/in/david-wele-b4509621b";
  };
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const handleSubmit = (e) => {
    e.preventDefault();
    alert("Message envoyé ! (Simulation)");
    setForm({ name: "", email: "", message: "" });
  };
  return (
    <Section>
      {" "}
      <h2 className="md:text-3xl text-2xl font-bold text-center mb-8 text-blue-600">
        Contactez <strong className="text-orange-400">-moi</strong>
      </h2>{" "}
      <div className=" flex md:flex-row-reverse justify-between space-x-4 flex-col items-center ">
        <div className=" md:w-[50%] w-[100%] mt-3 ">
          <form
            onSubmit={handleSubmit}
            className="max-w-lg mx-auto space-y-4  p-1"
          >
            {" "}
            <div
              className="w-full space-x-1 border-blue-400 border-1 border rounded focus:outline-none 
        flex flex-row items-center bg-white"
            >
              <i className=" fas fa-user text-blue-600 p-1"></i>
              <input
                type="text"
                placeholder="Votre nom"
                value={form.name}
                onChange={(e) => setForm({ ...form, name: e.target.value })}
                className="w-full p-2  rounded focus:outline-none dark:focus:text-blue-600 focus:text-blue-600"
                required
              />{" "}
            </div>
            <div className="w-full space-x-1 border-blue-400 border-1 border rounded focus:outline-none bg-white flex flex-row items-center">
              <i className=" fas fa-envelope text-blue-600 p-1"></i>
              <input
                type="email"
                placeholder="Votre email"
                value={form.email}
                onChange={(e) => setForm({ ...form, email: e.target.value })}
                className="w-full p-2  rounded focus:outline-none dark:focus:text-blue-600 focus:text-blue-600"
                required
              />{" "}
            </div>
            <div>
              <textarea
                placeholder="Votre message"
                value={form.message}
                onChange={(e) => setForm({ ...form, message: e.target.value })}
                className="w-full p-2 border rounded focus:outline-none focus:ring-2 focus:text-blue-600 focus:ring-blue-400
                 border-blue-400 border-1 dark:focus:text-blue-600"
                rows="4"
                required
              />{" "}
            </div>
            <div className="text-center">
              {" "}
              <Button text="Envoyer" color="bg-blue-600" />{" "}
            </div>{" "}
          </form>{" "}
        </div>
        <div className="md:w-[50%] text-blue-600 space-y-4 w-[100%] ">
          <div className=" flex justify-center items-center">
            <div className=" ">
              <div>
                <div className=" flex flex-row space-x-2 text-2xl font-bold text-blue-600 items-center mt-4">
                  <div>
                    <i className=" fas fa-envelope md:text-5xl text-xl"></i>
                  </div>
                  <div className=" md:text-lg text-lg">Adresse</div>
                </div>
                <div className=" space-y-3">
                  <div className=" md:text-2xl text-lg font-bold ">
                    devdesign
                  </div>
                  <div className=" font-medium md:text-[16px] text-[14px]">
                    <div>BURUNDI Bujumbura </div>
                    <div>Av.Ngagara Q.10</div>
                    <div>+257 69619884 /davidwele76@gmail.com</div>
                  </div>
                  <div></div>
                  <div
                    className=" flex flex-row justify-start space-x-4 mt-0 rounded-b-lg shadow-lg
                                text-2xl font-bold text-blue-600  p-3 w-[350px]"
                  >
                    <div>
                      <button onClick={rediFacebook}>
                        <i className=" fab fa-facebook"></i>
                      </button>
                    </div>
                    <div>
                      <button onClick={rediInstagram}>
                        <i className=" fab fa-instagram"></i>
                      </button>
                    </div>
                    <div>
                      <button onClick={rediPintrest}>
                        <i className=" fab fa-pinterest"></i>
                      </button>
                    </div>
                    <div>
                      <button onClick={rediLinkdin}>
                        <i className=" fab fa-linkedin"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Section>
  );
}
export default Contact;
*/

import { useState } from "react";
import Section from "../components/Section";
import Button from "../components/Button";
import emailjs from "@emailjs/browser"; // Importer EmailJS

function Contact() {
  const rediPintrest = () => {
    window.location.href = "https://pin.it/1agZp2YNs";
  };

  const rediFacebook = () => {
    window.location.href = "https://www.facebook.com/devdavid.welengenzu.3";
  };

  const rediInstagram = () => {
    window.location.href =
      "https://www.instagram.com/dev__well/profilecard/?igsh=czc4dXlucmU1aWx1";
  };

  const rediLinkdin = () => {
    window.location.href = "https://www.linkedin.com/in/david-wele-b4509621b";
  };

  const [form, setForm] = useState({ name: "", email: "", message: "" });

  const handleSubmit = (e) => {
    e.preventDefault();

    // Envoyer le formulaire via EmailJS
    emailjs
      .send(
        "service_q9i9znn", // Service ID
        "template_phvxffe", // Template ID
        {
          from_name: form.name,
          from_email: form.email,
          message: form.message,
        },
        "ILvGu9pmcklhCJ-_O" // Clé publique
      )
      .then(
        () => {
          alert("Message envoyé avec succès !");
          setForm({ name: "", email: "", message: "" }); // Réinitialiser le formulaire
        },
        (error) => {
          alert("Erreur lors de l'envoi : " + error.text);
        }
      );
  };

  return (
    <Section>
      <h2 className="md:text-3xl text-2xl font-bold text-center mb-8 text-blue-600">
        Contactez <strong className="text-orange-400">-moi</strong>
      </h2>
      <div className="flex md:flex-row-reverse justify-between space-x-4 flex-col items-center">
        <div className="md:w-[50%] w-[100%] mt-3">
          <form
            onSubmit={handleSubmit}
            className="max-w-lg mx-auto space-y-4 p-1"
          >
            <div className="w-full space-x-1 border-blue-400 border-1 border rounded focus:outline-none flex flex-row items-center bg-white">
              <i className="fas fa-user text-blue-600 p-1"></i>
              <input
                type="text"
                placeholder="Votre nom"
                value={form.name}
                onChange={(e) => setForm({ ...form, name: e.target.value })}
                className="w-full p-2 rounded focus:outline-none dark:text-blue-600 dark:focus:text-blue-600 focus:text-blue-600"
                required
              />
            </div>
            <div className="w-full space-x-1 border-blue-400 border-1 border rounded focus:outline-none bg-white flex flex-row items-center">
              <i className="fas fa-envelope text-blue-600 p-1"></i>
              <input
                type="email"
                placeholder="Votre email"
                value={form.email}
                onChange={(e) => setForm({ ...form, email: e.target.value })}
                className="dark:text-blue-600 w-full p-2 rounded focus:outline-none dark:focus:text-blue-600 focus:text-blue-600"
                required
              />
            </div>
            <div>
              <textarea
                placeholder="Votre message"
                value={form.message}
                onChange={(e) => setForm({ ...form, message: e.target.value })}
                className="dark:text-blue-600 w-full p-2 border rounded focus:outline-none focus:ring-2 focus:text-blue-600 focus:ring-blue-400 border-blue-400 border-1 dark:focus:text-blue-600"
                rows="4"
                required
              />
            </div>
            <div className="text-center">
              <Button text="Envoyer" color="bg-blue-600" />
            </div>
          </form>
        </div>
        <div className="md:w-[50%] text-blue-600 space-y-4 w-[100%]">
          <div className="flex justify-center items-center">
            <div>
              <div className="flex flex-row space-x-2 text-2xl font-bold text-blue-600 items-center mt-4">
                <div>
                  <i className="fas fa-envelope md:text-5xl text-xl"></i>
                </div>
                <div className="md:text-lg text-lg">Adresse</div>
              </div>
              <div className="space-y-3">
                <div className="md:text-2xl text-lg font-bold">devdesign</div>
                <div className="font-medium md:text-[16px] text-[14px]">
                  <div>BURUNDI Bujumbura</div>
                  <div>Av.Ngagara Q.10</div>
                  <div>+257 69619884 / davidwele76@gmail.com</div>
                </div>
                <div className="flex flex-row justify-start space-x-4 mt-0 rounded-b-lg shadow-lg text-2xl font-bold text-blue-600 p-3 w-[350px]">
                  <div>
                    <button onClick={rediFacebook}>
                      <i className="fab fa-facebook"></i>
                    </button>
                  </div>
                  <div>
                    <button onClick={rediInstagram}>
                      <i className="fab fa-instagram"></i>
                    </button>
                  </div>
                  <div>
                    <button onClick={rediPintrest}>
                      <i className="fab fa-pinterest"></i>
                    </button>
                  </div>
                  <div>
                    <button onClick={rediLinkdin}>
                      <i className="fab fa-linkedin"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Section>
  );
}

export default Contact;
